import { AnyAction } from 'redux';
import { handleActions } from 'redux-actions';

import { getTutorialVideoAction, getTutorialVideosAction } from './TutorialVideosActionConfig';

const defaultState = {
  tutorial: {},
  data: {},
};

type State = typeof defaultState;

const reducer = handleActions<State, AnyAction>({
  [`${getTutorialVideosAction}`](state: State, { payload }: AnyAction) {
    return {
      ...state,
      data: payload,
    };
  },
  [`${getTutorialVideoAction}`](state: State, { payload }: AnyAction) {
    return {
      ...state,
      tutorial: payload,
    };
  },
}, defaultState);

export default reducer;
